module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SV - El Salvador.0e609f37.svg";